<template>
  <v-menu
    v-model="show"
    bottom
    left
    :disabled="finallyDisabled"
    nudge-bottom="50"
    nudge-left="40"
    :close-on-content-click="false"
    min-width="350px"
    max-width="500px"
    class="cell-menu"
  >
    <template #activator="{on, attrs}">
      <span
        v-on="on"
        v-bind="attrs"
        @click="openMenu"
        :class="[ {'cell-menu-item__disabled': finallyDisabled,'d-flex flex-row align-center justify-space-between': !!offers && offers.length}]"
      >
        <span class="cell-menu-item" :class="{'cell-menu-item__disabled': finallyDisabled,}">{{ valueFormatted }}</span>
        <v-icon v-if="isMain && !finallyDisabled && !!offers && offers.length" size="44" color="warning" class="ml-3"
                style="max-height: 25px!important;">
          mdi-circle-small
        </v-icon>
      </span>
    </template>
    <v-card class="contact-menu-card">
      <v-btn class="close-click" icon @click="show = false">
        <v-icon size="24" color="#0288D1">mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h3>
          <slot name="header-title">
            Предложение головного ЦО
          </slot>
        </h3>
      </v-card-title>
      <v-card-text
        class="d-flex flex-column"
      >
        <v-row dense>
          <v-col class="d-flex flex-column">
            <div>Предложение текущее</div>
            <div>
              <v-text-field
                :value="valueFormatted"
                type="Number"
                disabled
                outlined
                background-color="#F5F6F8"
                height="32"
                class=""
                dense
                required
              />
            </div>
          </v-col>
          <v-col v-if="stageNumber < 3 && !isMinCultMinZdravCheck" class="d-flex flex-column">
            <div style="min-height: 22px"></div>
            <div class="d-flex flex-column ml-5">
              <span>Минимум: {{ minValue }}</span>
              <span>Максимум: {{ maxValue }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="saveData"
            >
              <div>Предложение новое</div>
              <div>
                <v-text-field
                  v-model="currentValue"
                  type="Number"
                  :rules="valMenuRules()"
                  outlined
                  background-color="#E3EFFA"
                  height="32"
                  dense
                  required
                />
              </div>
              <div v-if="!isBSM && isMain">Обоснование для изменения</div>
              <div v-if="!isBSM && isMain">
                <v-textarea
                  :rules="textMenuRules()"
                  v-model="currentValueText"
                  type="text"
                  :background-color="currentValue ? '#E3EFFA' : '#F5F6F8'"
                  :disabled="!currentValue"
                  required
                  outlined
                  auto-grow
                ></v-textarea>
              </div>
            </v-form>
          </v-col>
        </v-row>
        <div v-if="this.isMain && offers.length" class="main-color font-weight-600">Предложения ЦО:</div>
        <template>
          <div v-for="offer in offers" :key="offer.id">
            {{ offer.founder.name }} — {{ offer.value }}
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-btn class="white__v-btn" :loading="loading" @click="saveData" @keyup.enter="saveData">Сохранить</v-btn>
        <v-btn class="error__v-btn" @click="show = !show">Отменить</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import CoStagesController from "@/controllers/OKCP/CoStagesController";
import RegionStageController from "@/controllers/OKCP/RegionStageController";

export default {
  name: "tableCellCo123Menu",
  props: {
    stageNumber: {
      type: Number,
      default: 1,
      validator: (v) => {
        return [1, 2, 3].includes(v)
      },
    },
    value: {
      type: [String, Number],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isMain: {
      type: Boolean,
      default: true
    }, //kcpGroupIsMain
    id: {
      type: [Number, String],
      required: true,
      default: 0,
      validator: (v) => {
        return +v > 0
      },
    },
    row: {
      type: Object,
      default: () => ({})
    },
    nameChangedField: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      show: false,
      valid: false,
      loading: false,
      loadingAdditionalInfo: false,
      currentValue: null,
      currentValueText: null,
      cellData: {},
    }
  },
  computed: {
    ...mapGetters('keycloak', {getAuthData: 'getAuthData'}),
    ...mapGetters('keycloak', {getFakeUser: 'getFakeUser', userId: 'userId'}),
    isMinCultMinZdravCheck() {
      if (this.getFakeUser?.role === "FOUNDER_ROLE" && (this.getFakeUser?.id === 6 || this.getFakeUser?.id === 8)) {
        return true
      } else return this.getAuthData.realm_access.roles.includes("FOUNDER_ROLE") && (this.userId === 6 || this.userId === 8);
    },
    finallyDisabled() {
      return this.disabled || (this.valueFormatted === 'н.д.' && this.isMain)
    },
    maxValue() {
      const value = this.row.startValue + Math.ceil(this.row.startValue * 0.1) + this.row.addValue + this.row.freeValue;
      return Number.isNaN(value) ? 0 : value;
    },
    minValue() {
      const value = this.row.startValue - Math.ceil(this.row.startValue * 0.1);
      return Number.isNaN(value) ? 0 : value
    },
    offers() {
      return this.isMain ? (this.row?.stageDataOffers ?? []) : []
    },
    currentOffer() {
      return this.row.stageDataOffers?.find(el => (el.founder.id === (this.getAuthData?.founderID ?? store.getters['keycloak/getFakeUser']?.id)) && el.stageId === this.stageNumber)
    },
    textCheck() {
      // console.log(this.currentValueText, Number(this.currentValue), this.row.startValue, `uslID = ${this.row.kcpGroup.usl.id === (1 || 2 || 3)}`);
      return (this.currentValueText && Number(this.currentValue) > this.row.startValue)
        /*|| this.row.kcpGroup.usl.id === (1 || 2 || 3)*/
        || Number(this.currentValue) <= this.row.startValue
    },
    valueFormatted() {
      if (this.$consts.groupSpecialRegions.includes(this.row.regionId))
        return this.value ? this.value : 0;
      if (this.$consts.specialRegions.includes(this.row.regionId))
        return ' - ';
      if (this.isMain)
        return this.value ? this.value : 0;
      else {
        // console.log((this.row.regionName === 'Российская Федерация' || this.row.districtId),(this.row.regionName === 'Российская Федерация' || this.row.districtId) ? this.row.value : this.currentOffer?.value ?? 0)
        return this.value ?? (this.currentOffer?.value ?? 0);
      }
    },
    isBSM() {
      return this.row?.kcpGroup?.usl?.id === 1 || this.row?.kcpGroup?.usl?.id === 2 || this.row?.kcpGroup?.usl?.id === 3
    }
  },
  created() {
    this.getStageValue();
  },
  methods: {
    async getStageValue() {
      if (this.stageNumber === 3 && this.row.stage3OfferValue === null) {
        this.currentValue = this.row.startValueStage3
      } else if (this.row.stage3OfferValue >= 0) {
        this.currentValue = this.row.stage3OfferValue
      } else if (this.stageNumber === 2) {
        this.currentValue = this.row.stage2Value
      }
      this.currentValueText = this.cellData?.comment
    },
    validate() {
      this.$refs.form.validate()
    },
    async openMenu() {
      if (this.disabled) return;
      this.show = !this.show
      this.cellData = await CoStagesController.getCoDataById(this.id);
      if (this.cellData?.comment) {
        this.currentValueText = this.cellData?.comment
      }
    },
    valMenuRules() {
      const result = [
        value => (!!value) || 'введите значение',
        value => (value >= 0) || 'значение может быть только положительным'
      ];
      if (this.stageNumber < 3 && this.getAuthData?.founderID !== 6 && this.getAuthData?.founderID !== 8 && this.getFakeUser?.founderID !== 6 && this.getFakeUser?.founderID !== 8) {
        result.push(
          value => (Number(value) === 0 || (value && Number(this.currentValue) >= this.minValue)) || 'значение не должно быть меньше минимального',
          value => (value && Number(this.currentValue) <= this.maxValue) || 'значение не должно превышать максимальное'
        )
      }
      return result
    },
    textMenuRules() {
      return [
        text => (text && Number(this.currentValue) === 0) || this.textCheck || 'Введенное значение должно быть не меньше значения прогноза',
        text => text && text.length >= 20 || this.textCheck || 'Поле не может содержать меньше 20 символов'
      ]
    },
    async saveData() {
      try {
        this.loading = true;
        await this.validate();
        if (this.valid) {
          if (this.isMain) {
            await RegionStageController.saveData(this.row?.id, this.stageNumber, this.currentValue, this.currentValueText)
              .then(data => this.emitSavedData(data[this.nameChangedField]));
          } else {
            await CoStagesController.saveDataOffer(this.row?.id, this.stageNumber, this.currentValue, this.currentOffer?.id, this.currentValueText)
              .then(data => this.emitOffer(data));
          }
          this.show = false
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    emitSavedData(value) {
      this.$emit('update', {row: this.row, dataField: this.nameChangedField, value: Number.parseInt(value)})
      if (this.stageNumber === 3) {
        this.$emit('getAll');
      }
    },
    emitOffer(value) {
      this.$emit('update-offer', {row: this.row, offer: value});
    }
  },
}
</script>

<style scoped>

</style>